import { useLang } from "../../contexts/LanguageContext";
import { imageUrl } from "../../lib/api";

export default function Footer({ content }) {
  const { t } = useLang();
  const cols = content?.footer?.columns || [];
  const wordmark = t(content?.logo?.wordmark) || "Cipta Andalan";

  return (
    <footer className="bg-[#1b1c1e] text-white border-t border-white/10" data-testid="site-footer">
      <div className="container-x py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              {content?.logo?.image ? (
                <img
                  src={imageUrl(content.logo.image)}
                  alt={wordmark}
                  className="h-6 w-auto max-w-[120px] object-contain"
                />
              ) : (
                <span className="inline-block w-4 h-4 bg-white" aria-hidden />
              )}
              <span className="font-display font-bold text-xl">{wordmark}</span>
            </div>
            <p className="text-white/60 text-[15px] leading-relaxed max-w-[40ch]">
              {t(content?.footer?.blurb)}
            </p>
          </div>
          <div className="md:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
            {cols.map((c, i) => (
              <div key={i}>
                <div className="eyebrow text-white/50 mb-4">{t(c.title)}</div>
                <ul className="space-y-3">
                  {c.links?.map((l, j) => (
                    <li key={j}>
                      <a
                        href={l.href}
                        className="text-white/85 hover:text-white text-[15px]"
                        data-testid={`footer-link-${i}-${j}`}
                      >
                        {t(l.label)}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-wrap items-center justify-between gap-3 text-[13px] text-white/50">
          <div>{content?.footer?.copyright}</div>
          <div>PT Cipta Andalan Persada</div>
        </div>
      </div>
    </footer>
  );
}
